import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import {PublicModule} from './app/standalone-features/public/public.module'
import { environment } from './environments/environment';

import { environmentLoader as environmentLoaderPromise } from './environments/environmentLoader';
import * as wjcCore from '@grapecity/wijmo';
import { LicenseManager } from 'ag-grid-enterprise';

environmentLoaderPromise.then(env => {
  // ITP-E-322-01: environment.json is in (the start-up timing marks: index.html itp:boot:*).
  performance.mark('itp:boot:env');
  if (env.production) {
    enableProdMode();

  }
  environment.dynamicsettings = env.dynamicsettings;
  if( environment.dynamicsettings['OrbitaxPlatformGtag'] ){

    const d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = 'https://www.googletagmanager.com/gtag/js?id='+ environment.dynamicsettings['OrbitaxPlatformGtag']; s.parentNode.insertBefore(g, s);

    (window as any).orbitaxPlatformGtag('js', new Date());
    (window as any).orbitaxPlatformGtag('config',  environment.dynamicsettings['OrbitaxPlatformGtag']);
  }
  wjcCore.setLicenseKey(env.dynamicsettings['WijmoDistributionLicenseKey']);
  LicenseManager.setLicenseKey(env.dynamicsettings['AgGridLicenseKey']);
  if(/\/user-consent(\/|$|\?|#)/i.test(window.location.href)){
    platformBrowserDynamic().bootstrapModule(PublicModule).catch(err => {
      console.log(err);
    });
  }else{
    platformBrowserDynamic().bootstrapModule(AppModule, {
      // Batch change detection across all event listeners firing in the same
      // microtask. Without this, every @HostListener('document:*') + Wijmo
      // document listener runs its own full CD pass per keystroke (~25ms lag
      // in dialog inputs while the spreadsheet is alive).
      // ngZoneEventCoalescing: true,
      // ngZoneRunCoalescing: true,
    }).then(() => {
      // ITP-E-319-07: Angular is up - the start-up loader's bar (index.html window.__itpBoot) moves to its app stage.
      (window as any).__itpBoot?.stage('app');
    }).catch(err => {
      console.log(err);
    });
  }


});

